export default __webpack_public_path__ + "a284f750338e65d66f42a5509272cc01.webp";